import {
  closedAdblockDetectModal,
  hideUpdateBillingInfoAlert,
  saveAdblockDetectModalStatus,
  shouldHideUpdateBillingInfoAlert,
} from '../../utils/storage'
import { updateUserLimitsStorage } from '../../utils/userAuth'
import {
  FETCH_USER,
  LOAD_LANGUAGE,
  UPDATE_USER,
  UPDATE_USER_PREFERENCES,
  UPDATE_LIFETIME_REMINDER_MODAL,
  UPDATE_NAVIGATION_CHANGE_MODAL,
  UPDATE_USER_FAMILIAR_WITH_BANNER,
  UPDATE_USER_SMART_THUMB_POPUP,
  FETCH_SUBSCRIPTION,
  FETCH_ADDONS,
  FETCH_MAIN_USER,
  FETCH_MULTI_USERS,
  FETCH_INVITED_USERS,
  UPDATE_LOGIN_LIMIT_MODAL,
  CLOSE_UPDATE_BILLING_INFO_ALERT,
  SET_EXTRA_HEADER_HEIGHT,
  DETECT_ADBLOCKER,
  CLOSE_ADBLOCK_MODAL,
  UPDATE_PROMPT_MODAL,
  UPDATE_AIW_PLAN_MODAL,
  UPDATE_ATP_CROSS_SELL_MODAL,
  DELETE_INVITED_USER,
  FETCH_USER_LIMITS,
  UPDATE_USER_LIMITS,
} from '../actions/global'

const initialState = {
  languageLoaded: false,
  user: null,
  isLoadingUser: true,
  isLoadingSubscription: true,
  isLoadingAddons: true,
  isUpdatingUser: false,
  lifetimeReminderModal: {
    isOpen: false,
  },
  navigationChangeModal: {
    isOpen: false,
  },
  aiwPlanModal: {
    isOpen: false,
  },
  atpCrossSellModal: {
    isOpen: false,
  },
  multiUsers: {
    data: [],
    isLoadingMultiUsers: false,
    isMultiUserRemoveModalOpen: false,
  },
  invitedUsers: {
    data: [],
    isLoadingInvitedUsers: false,
  },
  loginLimitModal: {
    isOpen: false,
  },
  promptModal: {
    isOpen: false,
  },
  extraHeaderHeight: 0,
  isCheckingAdblock: true,
  isDetectedAdblock: false,
  isClosedAdblockDetectModal: closedAdblockDetectModal(),
  hideUpdateBillingInfoAlert: shouldHideUpdateBillingInfoAlert(),
}

const appReducer = (state = initialState, action = undefined) => {
  let resultState = null
  switch (action.type) {
    case LOAD_LANGUAGE.success:
      resultState = {
        ...state,
        languageLoaded: true,
      }
      break
    case FETCH_USER.action:
      resultState = {
        ...state,
        isUpdatingUser: true,
      }
      break
    case FETCH_USER.success:
      resultState = {
        ...state,
        user: action.payload,
        isLoadingUser: false,
        isUpdatingUser: false,
      }
      break
    case UPDATE_USER.action:
      resultState = {
        ...state,
        isUpdatingUser: true,
      }
      break
    case UPDATE_USER.success:
      resultState = {
        ...state,
        isUpdatingUser: false,
        user: {
          ...state.user,
          ...action.payload,
        },
      }
      break
    case UPDATE_USER_LIMITS.success:
      resultState = {
        ...state,
        isUpdatingUser: false,
        user: {
          ...state.user,
          limits: {
            ...state.user.limits,
            ...action.payload,
          },
        },
      }
      updateUserLimitsStorage({
        ...state.user.limits,
        ...action.payload,
      })
      break
    case FETCH_MAIN_USER.success:
      resultState = {
        ...state,
        user: {
          ...state.user,
          mainUser: action.payload,
        },
      }
      break
    case FETCH_MULTI_USERS.action:
      resultState = {
        ...state,
        multiUsers: {
          ...state.multiUsers,
          isLoadingMultiUsers: true,
        },
      }
      break
    case FETCH_MULTI_USERS.success:
      resultState = {
        ...state,
        multiUsers: {
          data: action.payload,
          isLoadingMultiUsers: false,
        },
      }
      break
    case FETCH_INVITED_USERS.action:
      resultState = {
        ...state,
        invitedUsers: {
          ...state.invitedUsers,
          isLoadingInvitedUsers: true,
        },
      }
      break
    case FETCH_INVITED_USERS.success:
      resultState = {
        ...state,
        invitedUsers: {
          data: action.payload,
          isLoadingInvitedUsers: false,
        },
      }
      break
    case FETCH_INVITED_USERS.failed:
      resultState = {
        ...state,
        invitedUsers: {
          ...state.invitedUsers,
          isLoadingInvitedUsers: false,
        },
      }
      break
    case DELETE_INVITED_USER.action:
      resultState = {
        ...state,
        invitedUsers: {
          ...state.invitedUsers,
          data: state.invitedUsers.data.map((u) =>
            u.email === action.payload ? { ...u, isLoading: true } : u,
          ),
        },
      }
      break
    case DELETE_INVITED_USER.success:
      resultState = {
        ...state,
        invitedUsers: {
          ...state.invitedUsers,
          data: state.invitedUsers.data.filter(
            (u) => u.email !== action.payload,
          ),
        },
      }
      break
    case DELETE_INVITED_USER.failed:
      resultState = {
        ...state,
        invitedUsers: {
          ...state.invitedUsers,
          data: state.invitedUsers.data.map((u) =>
            u.email === action.payload ? { ...u, isLoading: false } : u,
          ),
        },
      }
      break
    case FETCH_SUBSCRIPTION.action:
      resultState = {
        ...state,
        isLoadingSubscription: true,
      }
      break
    case FETCH_USER_LIMITS.action:
      resultState = {
        ...state,
        isLoadingSubscription: true,
      }
      break
    case FETCH_SUBSCRIPTION.success:
      resultState = {
        ...state,
        user: {
          ...state.user,
          subscription: {
            ...state.user.subscription,
            ...action.payload,
          },
        },
        isLoadingSubscription: false,
      }
      break
    case FETCH_USER_LIMITS.success:
      resultState = {
        ...state,
        user: {
          ...state.user,
          limits: {
            ...state.user.limits,
            ...action.payload,
          },
        },
        isLoadingSubscription: false,
      }
      break
    case FETCH_ADDONS.action:
      resultState = {
        ...state,
        isLoadingAddons: true,
      }
      break
    case FETCH_ADDONS.success:
      resultState = {
        ...state,
        user: {
          ...state.user,
          addons: action.payload,
        },
        isLoadingAddons: false,
      }
      break
    case UPDATE_USER_PREFERENCES.success:
      resultState = {
        ...state,
        user: {
          ...state.user,
          preferences: action.payload,
        },
      }
      break
    case UPDATE_USER_FAMILIAR_WITH_BANNER:
    case UPDATE_USER_SMART_THUMB_POPUP:
      resultState = {
        ...state,
        user: action.payload,
      }
      break
    case UPDATE_LIFETIME_REMINDER_MODAL.action:
      resultState = {
        ...state,
        lifetimeReminderModal: action.payload,
      }
      break
    case UPDATE_NAVIGATION_CHANGE_MODAL.action:
      resultState = {
        ...state,
        navigationChangeModal: action.payload,
      }
      break
    case UPDATE_AIW_PLAN_MODAL.action:
      resultState = {
        ...state,
        aiwPlanModal: action.payload,
      }
      break
    case UPDATE_LOGIN_LIMIT_MODAL.action:
      resultState = {
        ...state,
        loginLimitModal: action.payload,
      }
      break
    case UPDATE_ATP_CROSS_SELL_MODAL.action:
      resultState = {
        ...state,
        atpCrossSellModal: action.payload,
      }
      break
    case CLOSE_UPDATE_BILLING_INFO_ALERT.action:
      resultState = {
        ...state,
        hideUpdateBillingInfoAlert: true,
      }
      hideUpdateBillingInfoAlert()
      break
    case SET_EXTRA_HEADER_HEIGHT.action:
      resultState = {
        ...state,
        extraHeaderHeight: action.payload,
      }
      break
    case DETECT_ADBLOCKER.action:
      resultState = {
        ...state,
        isCheckingAdblock: true,
        isDetectedAdblock: false,
      }
      break
    case DETECT_ADBLOCKER.success:
      resultState = {
        ...state,
        isCheckingAdblock: false,
        isDetectedAdblock: action.payload,
      }
      break
    case CLOSE_ADBLOCK_MODAL.action:
      resultState = {
        ...state,
        isClosedAdblockDetectModal: true,
      }
      saveAdblockDetectModalStatus()
      break
    case UPDATE_PROMPT_MODAL.action:
      resultState = {
        ...state,
        promptModal: action.payload,
      }
      break
    case UPDATE_PROMPT_MODAL.canceled:
      resultState = {
        ...state,
        promptModal: {
          isOpen: false,
          from: state.promptModal.from,
        },
      }
      break
    default:
      return state
  }

  if (!resultState) {
    resultState = {
      ...state,
    }
  }
  return resultState
}

export default appReducer
